import { useEffect, useState } from "react"

export type AppVersionInfo = {
  version: string
  /** Second line of `version.txt` (e.g. release date), when present */
  releaseDate: string | null
}

function parseVersionTxt(text: string): { version: string | null; releaseDate: string | null } {
  const lines = text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
  if (lines.length === 0) {
    return { version: null, releaseDate: null }
  }
  return {
    version: lines[0] ?? null,
    releaseDate: lines[1] ?? null,
  }
}

export function useAppVersion(): AppVersionInfo {
  const envRaw = import.meta.env.VITE_APP_VERSION
  const envVersion = typeof envRaw === "string" ? envRaw.trim() : ""
  const [info, setInfo] = useState<AppVersionInfo>({
    version: envVersion,
    releaseDate: null,
  })

  useEffect(() => {
    fetch("/version.txt", { cache: "no-store" })
      .then((response) => (response.ok ? response.text() : ""))
      .then((text) => {
        const parsed = parseVersionTxt(text)
        setInfo({
          version: parsed.version ?? envVersion,
          releaseDate: parsed.releaseDate,
        })
      })
      .catch(() => { })
  }, [envVersion])

  return info
}
